import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import MarketerReports from "./MarketerReports";
import MarketersOverview from "./MarketersOverview";
import { Tabs } from "@mantine/core";
import MarketersProducts from "./MarketersProducts";

const Marketer = () => {
  const { lang } = useParams();
  const [_] = useTranslation("global");
  const box_head_dir = lang === "en" ? "ltr" : "rtl";

  return (
    <div className="flex-grow-1 stats-component" dir={box_head_dir}>
      <Helmet>
        <title>{_("panel.marketersPerformance")}</title>
      </Helmet>

      <div className="reports-container my-3 d-flex flex-column gap-2 px-2 position-relative">
        <div className="reports-header d-flex flex-column flex-md-row py-2 justify-content-between flex-wrap">
          <h3 className="fs-2 mb-4" style={{ color: "rgba(89, 198, 201, 1)" }}>
            {_("panel.marketersPerformance")}
          </h3>
        </div>

        <Tabs defaultValue="marketerOverview">
          <Tabs.List grow>
            <Tabs.Tab
              value="marketerOverview"
              className="fs-5"
              color="rgb(89, 198, 201)"
            >
              {_("panel.marketerOverview")}
            </Tabs.Tab>
            <Tabs.Tab
              value="affiliate"
              className="fs-5"
              color="rgb(89, 198, 201)"
            >
              {_("panel.affiliate")}
            </Tabs.Tab>
            <Tabs.Tab
              value="productsOverview"
              className="fs-5"
              color="rgb(89, 198, 201)"
            >
              {_("panel.productsOverview")}
            </Tabs.Tab>
          </Tabs.List>
          <Tabs.Panel value="marketerOverview">
            <MarketersOverview />
          </Tabs.Panel>

          <Tabs.Panel value="affiliate">
            <MarketerReports />
          </Tabs.Panel>
          <Tabs.Panel value="productsOverview">
            <MarketersProducts />
          </Tabs.Panel>
        </Tabs>
      </div>
    </div>
  );
};

export default Marketer;
